import type { MediaType } from "./media";

export interface CategoryMeta {
  type: MediaType;
  label: string;
  englishName: string;
  description: string;
  icon: string;
  cover: string;
}

export const CATEGORIES: CategoryMeta[] = [
  {
    type: "movie",
    label: "电影",
    englishName: "Movies",
    description: "从动作大片到文艺佳作，汇集全球优质电影作品，按题材、地区与年份轻松筛选。",
    icon: "ri-film-line",
    cover: "https://readdy.ai/api/search-image?query=cinema%20projector%20beam%20in%20a%20dark%20auditorium%20with%20deep%20blue%20shadows%20and%20warm%20orange%20light%2C%20cinematic%20still%2C%20no%20text&width=800&height=600&seq=17c-cat-movie&orientation=landscape",
  },
  {
    type: "series",
    label: "电视剧",
    englishName: "TV Series",
    description: "悬疑、年代、都市、古装应有尽有，追剧党必看的热门剧集与高分口碑剧一网打尽。",
    icon: "ri-tv-2-line",
    cover: "https://readdy.ai/api/search-image?query=cozy%20living%20room%20with%20a%20glowing%20tv%20screen%20at%20night%2C%20deep%20blue%20shadows%20and%20warm%20orange%20lamp%2C%20cinematic%20still%2C%20no%20text&width=800&height=600&seq=17c-cat-series&orientation=landscape",
  },
  {
    type: "variety",
    label: "综艺",
    englishName: "Variety Shows",
    description: "竞技、旅行、音乐、美食等热门综艺，欢乐与治愈随时在线，下饭必备。",
    icon: "ri-mic-line",
    cover: "https://readdy.ai/api/search-image?query=colorful%20variety%20show%20stage%20with%20deep%20blue%20and%20orange%20spotlights%2C%20energetic%20mood%2C%20cinematic%20still%2C%20no%20text&width=800&height=600&seq=17c-cat-variety&orientation=landscape",
  },
];

export const REGIONS: string[] = ["全部", "中国", "美国", "英国", "韩国", "日本"];

export const YEARS: { label: string; value: string }[] = [
  { label: "全部年份", value: "all" },
  { label: "2026", value: "2026" },
  { label: "2025", value: "2025" },
  { label: "2024", value: "2024" },
  { label: "经典（2023 及以前）", value: "classic" },
];

export const SORT_OPTIONS: { label: string; value: string }[] = [
  { label: "最新发布", value: "latest" },
  { label: "热门推荐", value: "hot" },
  { label: "评分最高", value: "rating" },
];

export const GENRES_BY_TYPE: Record<MediaType, string[]> = {
  movie: ["全部", "剧情", "动作", "科幻", "悬疑", "喜剧", "惊悚", "犯罪", "家庭"],
  series: ["全部", "悬疑", "都市", "历史", "古装", "医疗", "年代", "科幻", "谍战", "生活"],
  variety: ["全部", "喜剧", "竞技", "旅行", "音乐", "美食", "益智", "选秀", "生活"],
};